<template>
  <ul class="nav nav-tabs bg-transparent tab-lemon">
    <li class="nav-item">
      <a
        :class="this.activeTab == 'Excursions' ? 'nav-link active disabled' : 'nav-link'"
        
        @click.prevent="navigate('Excursions', 'Activity')"
      >Excursiones</a>
    </li>
    <li class="nav-item">
      <a
        :class="this.activeTab == 'Pickups' ? 'nav-link active disabled' : 'nav-link'"
        
        @click.prevent="navigate('Pickups', 'Stop')"
      >Recogidas</a>
    </li>
    <li class="nav-item">
      <a
        :class="this.activeTab == 'Returns' ? 'nav-link active disabled' : 'nav-link'"
        
        @click.prevent="navigate('Returns', 'Stop')"
      >Dejadas</a>
    </li>

    <li class="nav-item">
      <a
        :class="this.activeTab == 'Check' ? 'nav-link active disabled' : 'nav-link'"
        @click.prevent="navigate('Check', '')"
      >     
        <i
          v-if="this.$store.state.bookings.hasBookingsUnchecked"
          class="fa fa-bell mr-1 text-danger"
          
        ></i>     
        Chequeo reservas
      </a>
    </li>

    <li class="nav-item">
      <a
        :class="this.activeTab == 'Unassigned' ? 'nav-link active disabled' : 'nav-link'"
        
        @click.prevent="navigate('Unassigned', '')"
      >
        <i
          v-if="this.$store.state.bookings.hasBookingsUnassigned"
          class="fa fa-bell mr-1 text-danger"
          
        ></i> Reservas sin parada
      </a>
    </li>
    <li class="nav-item">
      <a
        :class="this.activeTab == 'Orphan' ? 'nav-link active disabled' : 'nav-link'"
        
        @click.prevent="navigate('Orphan', '')"
      >
        <i
          v-if="this.$store.state.bookings.hasBookingsOrphanGroup"
          class="fa fa-bell mr-1 text-danger"
          
        ></i> Reservas sin grupo
      </a>
    </li>

    <li class="nav-item">
      <a
        :class="this.activeTab == 'Plan' ? 'nav-link active disabled' : 'nav-link'"
        
        @click.prevent="navigate('Plan', '')"
      >
        Plan del día
      </a>
    </li>

    <li class="nav-item">
      <a
        :class="this.activeTab == 'Send' ? 'nav-link active disabled' : 'nav-link'"
        
        @click.prevent="navigate('Send', '')"
      >          
        Envío planificación
      </a>
    </li>

  </ul>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";

export default {
  methods: {
    async navigate(tab, option) {
      await this.$store.dispatch("layout/setActiveTabAndOption", {tab: tab, option: option})
      if ( this.activeTab === 'Excursions') {
        this.$router.push('/app/excursiones/excursiones')
      } else if ( this.activeTab === 'Pickups') {
        this.$router.push('/app/excursiones/pickups')
        this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
      } else if ( this.activeTab == 'Returns') {
        this.$router.push('/app/excursiones/returns')
        this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
      }else if (this.activeTab === 'Unassigned') {
        this.$router.push('/app/excursiones/reservas-sin-parada')
        this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
      } else if ( this.activeTab == 'Orphan' ) {
        this.$router.push('/app/excursiones/reservas-sin-grupo')
        this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
      } else if ( this.activeTab === 'Send') {
        this.$router.push('/app/excursiones/envio-planificacion')
        this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
      } else if ( this.activeTab == 'Plan' ) {
        this.$router.push('/app/excursiones/planificacion-dia')
        //this.$store.dispatch("layout/loadData", {reset: false}, {root: true})
      } else if ( this.activeTab == 'Check' ) {
        this.$router.push('/app/excursiones/check')
      }
      
    }
  },
  computed: {
    ...mapGetters(['activeOption', 'activeTab']),
  }
}
</script>


   